import auth from "./auth";
import api from "./api";

const SERVICE_URL = "organization-service/v1/cms/table-ordering/";

export default {
  getGroupTable({ payload, page }) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}group/table/list/${page}`,
        payload,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getTableList({ payload, page, uuid }) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}table/list/${uuid}/${page}`,
        payload,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  toggleTableVisibility(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}branch-table/update-status`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          resolve(response);
        })
        .catch(({ status, errors }) => {
          reject(errors);
        });
    });
  },
  createGroupTable(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}branch/table/create`,
        payload,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  viewGroupTable(uuid) {
    return new Promise((resolve, reject) => {
      api.get(
        `${SERVICE_URL}branch/table/view/${uuid}`,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  updateGroupTable(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}branch/table/update`,
        payload,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  deleteGroupTable(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}group/table/delete`,
        payload,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  deleteTable(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}table/delete`,
        payload,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  }
}
